import React, { useState, useEffect } from "react";
import { Suspense } from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  Link,
  Spinner,
} from "@chakra-ui/react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { DownloadIcon } from "../assets/svgs/Icons";
import RegistrationCert from "../Components/Certificates/RC";
import { getCompanyDetails } from "../redux/company/CompanySlice";
import DocumentViewer from "../Components/common/DocumentViewer";
import { unwrapResult } from "@reduxjs/toolkit";
import isAllowed from "../routing/isAllowed";

function MyDocuments() {
  const dispatch = useDispatch();

  const { userData } = useSelector((state) => state.auth);
  const { companyDetails } = useSelector((state) => state.company);

  const getUserData = () => {
    if (userData?.companyId) {
      try {
        const result = dispatch(getCompanyDetails(userData?.companyId));
        unwrapResult(result);
      } catch (error) {
        unwrapResult(error);
      }
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Box marginBottom={"2rem"}>
      <Flex justifyContent={"space-between"} alignItems="center">
        <Box marginTop="2rem">
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            My Documents
          </Text>
        </Box>
      </Flex>
      <Box>
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Registration Certificate
            </Text>
          </GridItem>
        </Grid>
        {companyDetails && (
          <Suspense
            fallback={
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Spinner width="50px" height="50px" color="#3958DC" />
                <Text marginLeft="10px">Loading the RC...</Text>
              </Box>
            }
          >
            <Box marginTop={"1rem"} marginBottom="1rem">
              <RegistrationCert application={companyDetails?.data} />
            </Box>
          </Suspense>
        )}
      </Box>
    </Box>
  );
}

export default isAllowed(MyDocuments);
